import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Text } from '../../component-text';
import { forwardRef } from 'react';
/**
 * The `PopoverText` should be used to display the text within a popover.
 */
export const PopoverText = forwardRef((props, ref) => (_jsx(Text, { size: "sm", variant: "default", color: "surface-onBase-50", emphasis: "high", ...props, ref: ref })));
PopoverText.displayName = 'PopoverText';
